import React, { useState, useEffect, useCallback } from 'react';
import { axios } from '../../context/AuthContext';

export default function AdminMufredatPage() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [siniflar, setSiniflar] = useState([]);
  const [dersler, setDersler] = useState([]);
  const [secSinif, setSecSinif] = useState('');
  const [secDers, setSecDers] = useState('');
  const [konular, setKonular] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    Promise.all([axios.get('/siniflar'), axios.get('/dersler')]).then(([sRes, dRes]) => {
      if (sRes.data.success) setSiniflar(sRes.data.data);
      if (dRes.data.success) setDersler(dRes.data.data);
    });
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const loadMufredat = useCallback(async () => {
    if (!secSinif || !secDers) return;
    setLoading(true);
    try {
      const { data } = await axios.get(`/mufredat/${secSinif}/${secDers}`);
      if (data.success) {
        setKonular(data.data.konular || []);
      }
    } catch {
      console.error("Müfredat yükleme hatası");
    } finally {
      setLoading(false);
    }
  }, [secSinif, secDers]);

  useEffect(() => { loadMufredat(); }, [loadMufredat]);

  const islendiCount = konular.filter(k => k.durum === 'islendi').length;
  const toplam = konular.length;
  const pct = toplam > 0 ? Math.round((islendiCount / toplam) * 100) : 0;

  const sinifAdi = siniflar.find(s => s.id == secSinif)?.ad || '';
  const dersAdi = dersler.find(d => d.id == secDers)?.ad || '';
  const dersRenk = dersler.find(d => d.id == secDers)?.renk || 'var(--blue)';

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: isMobile ? 16 : 20 }}>
      <div className="animate-fadeInUp">
        <h2 style={{ fontFamily: 'var(--font-ui)', fontWeight: 900, fontSize: isMobile ? '1.15rem' : '1.4rem' }}>📖 Müfredat Genel Bakış</h2>
        <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem', marginTop: 4 }}>Tüm sınıfların müfredat ilerlemesini buradan izleyebilirsiniz.</p>
      </div>

      <div className="card animate-fadeInUp">
        <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: 14 }}>
          <div className="form-group">
            <label className="form-label">Sınıf Seçin</label>
            <select className="form-input" value={secSinif} onChange={e => setSecSinif(e.target.value)}>
              <option value="">Sınıf Seçin</option>
              {siniflar.map(s => <option key={s.id} value={s.id}>{s.ad}</option>)}
            </select>
          </div>
          <div className="form-group">
            <label className="form-label">Ders Seçin</label>
            <select className="form-input" value={secDers} onChange={e => setSecDers(e.target.value)}>
              <option value="">Ders Seçin</option>
              {dersler.map(d => <option key={d.id} value={d.id}>{d.ad}</option>)}
            </select>
          </div>
        </div>
      </div>

      {secSinif && secDers && (
        <>
          <div className="card animate-fadeInUp" style={{ background: `linear-gradient(135deg, ${dersRenk}10, white)`, border: `1.5px solid ${dersRenk}20` }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
              <div>
                <div style={{ fontWeight: 900 }}>{sinifAdi} - <span style={{ color: dersRenk }}>{dersAdi}</span></div>
                <div style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>{islendiCount}/{toplam} Konu Tamamlandı</div>
              </div>
              <div style={{ fontSize: '2rem', fontWeight: 900, color: dersRenk }}>%{pct}</div>
            </div>
            <div style={{ height: 10, background: 'rgba(0,0,0,0.05)', borderRadius: 10 }}>
              <div style={{ height: '100%', width: `${pct}%`, background: dersRenk, borderRadius: 10, transition: 'width 0.5s' }} />
            </div>
          </div>

          <div className="card animate-fadeInUp">
            {loading ? <div className="spinner" /> : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                {konular.length === 0 ? <p>Konu bulunamadı.</p> : konular.map((k, i) => (
                  <div key={i} style={{
                    display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px',
                    background: k.durum === 'islendi' ? '#F0FDF4' : 'var(--bg-elevated)',
                    border: `1px solid ${k.durum === 'islendi' ? '#10B98130' : 'var(--border)'}`,
                    borderRadius: 12
                  }}>
                    <div>
                      <div style={{ fontWeight: 600, fontSize: '0.9rem', color: k.durum === 'islendi' ? '#065F46' : 'inherit' }}>{k.konu_adi}</div>
                      {k.durum === 'islendi' && (
                        <div style={{ fontSize: '0.7rem', color: '#10B981', marginTop: 2 }}>
                           ✅ {k.hoca_ad} {k.hoca_soyad} tarafından {new Date(k.tarih).toLocaleDateString('tr-TR')} tarihinde işlendi.
                        </div>
                      )}
                    </div>
                    {k.durum === 'islendi' ? (
                       <span className="badge" style={{ background: '#D1FAE5', color: '#10B981' }}>İşlendi</span>
                    ) : (
                       <span className="badge" style={{ background: '#F1F5F9', color: '#64748B' }}>Bekliyor</span>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}